import axios from 'axios';
import qs from 'qs'; // 处理数据格式
import wx from "weixin-js-sdk"


const request = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    withCredentials: true,
    crossDomain: true,
})

// request interceptor
request.interceptors.request.use(
    config => {
        if (localStorage.getItem('requestList')) {
            var requestList = JSON.parse(localStorage.getItem('requestList'))
        } else {
            var requestList = []
        }
        requestList.push(config.baseURL + config.url)
        const newrequestList = Array.from(new Set(requestList));
        localStorage.setItem('requestList', JSON.stringify(newrequestList))


        if (localStorage.getItem('Authorization')) {
            config.headers['Authorization'] = localStorage.getItem('Authorization')
        }
        if (config.method === 'get') { // get请求直接放过
            return config;
        }
        if (config.method === 'post' && config.qsFlag) { // post请求判断是否加了数据处理标志
            // POST传参序列化(添加请求拦截器)
            config.data = qs.stringify(config.data);
        }
        return config
    },
    error => {
        // do something with request error
        return Promise.reject(error)
    }
)

// TODO 401 未登录 全局拦截
// 响应拦截器
let isRedirecting = false; // 全局标志位
request.interceptors.response.use(res => {
    return res
    if (res.data.code == 401 && !isRedirecting) {
        isRedirecting = true; // 标记为正在跳转

        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            // ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
            wx.miniProgram.getEnv((res) => {
                if (res.miniprogram) {
                    console.log("在小程序里");
                    wx.miniProgram.navigateTo({
                        url: '/pages/login/login',
                        success: (res) => { console.log('成功') },
                        fail: (res) => { console.log('失败') },
                        complete: (res) => { console.log('完成') },
                    })
                } else {
                    console.log("不在小程序里");
                    window.location.href = process.env.VUE_APP_ZKING_BASE_API + '/app/sso-passport-authenticate/wecom/activityWxCode.html?wServerName=GW_KHJ2024&returnUrl=' + process.env.VUE_APP_ZKING_INDEX_PAGE
                }
            })
        } else {
            console.log('不在微信里');
            window.location.href = process.env.VUE_APP_ZKING_BASE_API + '/app/sso-passport-authenticate/wecom/activityWxCode.html?wServerName=GW_KHJ2024&returnUrl=' + process.env.VUE_APP_ZKING_INDEX_PAGE
        }
    } else {
        return res
    }
},
    error => { return Promise.reject(error) })


export default request
